import get from 'lodash/get';
import API from '@/api';

const types = {
  APPEND_NEW_TRANSACTION: 'APPEND_NEW_TRANSACTION',
  SET_TRANSACTIONS: 'SET_TRANSACTIONS',
  UPDATE_TRANSACTION: 'UPDATE_TRANSACTION',
  DELETE_TRANSACTION: 'DELETE_TRANSACTION',
  SET_CATEGORIES: 'SET_CATEGORIES',
  SET_BANKS: 'SET_BANKS',
  DELETE_BANK: 'DELETE_BANK',
};

const state = {
  transactions: [],
  categories: [],
  banks: [],
};

const getters = {
  transactions(state) {
    return state.transactions;
  },
};

const mutations = {
  [types.APPEND_NEW_TRANSACTION](state, newTransaction) {
    state.transactions = [newTransaction, ...state.transactions];
  },
  [types.SET_TRANSACTIONS](state, transactions) {
    // eslint-disable-next-line no-param-reassign
    state.transactions = transactions;
  },
  [types.UPDATE_TRANSACTION](state, updatedTransaction) {
    state.transactions.splice(
      state.transactions.findIndex(t => t.id === updatedTransaction.id),
      1,
      updatedTransaction,
    );
  },
  [types.SET_CATEGORIES](state, categories) {
    // eslint-disable-next-line no-param-reassign
    state.categories = categories;
  },
  [types.SET_BANKS](state, banks) {
    state.banks = banks;
  },
  [types.DELETE_TRANSACTION](state, transactionId) {
    state.transactions.splice(
      state.transactions.findIndex(t => t.id === transactionId),
      1,
    );
  },
  [types.DELETE_BANK](state, bankId) {
    state.banks.splice(
      state.banks.findIndex(b => b.id === bankId),
      1,
    );
  },
};

const actions = {
  async createAccounts({ commit, dispatch }, params) {
    try {
      const response = await API.integration.createAccounts(params);
      dispatch('getAllBanks', { companyId: params.companyId });
    } catch (e) {
      console.log(e);
    }
  },
  async updateAccount({ commit, dispatch }, params) {
    try {
      const response = await API.integration.updateAccount(params);
    } catch (e) {
      console.log(e);
    }
  },
  async deleteBank({ commit }, params) {
    try {
      const response = await API.integration.deleteBank(params);
      commit(types.DELETE_BANK, params.id);
    } catch (e) {
      console.log(e);
    }
  },
  async getAllBanks({ commit, dispatch }, params) {
    const response = await API.integration.getAllBanks(params.companyId);
    commit(types.SET_BANKS, response.data);
    if (!response.data.every(b => !b.processing)) {
      return setTimeout(() => {
        dispatch('getAllBanks', params);
      }, 2000);
    }
  },
  async createTransaction({ commit }, params) {
    try {
      const response = await API.integration.createTransaction(params);
      commit(types.APPEND_NEW_TRANSACTION, response.data);
    } catch (e) {
      this.$store.dispatch('application/setErrorNotification', {
        message: 'Something went wrong creating a transaction.',
      });
    }
  },
  async getAllTransactions({ commit }, { companyId, year }) {
    const response1 = await API.integration.getAllTransactionCategories(
      companyId,
    );
    commit(types.SET_CATEGORIES, response1.data);
    const response2 = await API.integration.getAllTransactions({
      companyId,
      year,
    });
    const transactions = response2.data.map(t => {
      return {
        ...t,
        type: response1.data.find(c => c.id === t.type_id).name,
      };
    });
    commit(types.SET_TRANSACTIONS, transactions);
  },
  async updateTransaction({ commit }, { transaction }) {
    try {
      const response = await API.integration.updateTransaction(transaction);
      commit(types.UPDATE_TRANSACTION, transaction);
      if (response.data.error) {
        this.$store.dispatch('application/setErrorNotification', {
          message: response.data.error,
        });
      }
    } catch (e) {
      console.log(e);
    }
  },
  async deleteTransaction({ commit }, params) {
    try {
      const response = await API.integration.deleteTransaction(params);
      commit(types.DELETE_TRANSACTION, params.id);
    } catch (e) {
      console.log(e);
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
